const SITE_URL = "https://premierelens.com";

export function resolveHomepageTargetYearMonth(releases = []) {
  const validDates = releases
    .map((show) => (typeof show?.releaseDate === "string" ? show.releaseDate : null))
    .filter((value) => value && /^\d{4}-\d{2}-\d{2}$/.test(value));

  const monthCounts = {};
  for (const date of validDates) {
    const yearMonth = date.slice(0, 7);
    monthCounts[yearMonth] = (monthCounts[yearMonth] || 0) + 1;
  }

  let targetYearMonth = null;
  let maxCount = 0;
  for (const [yearMonth, count] of Object.entries(monthCounts).sort((left, right) => left[0].localeCompare(right[0]))) {
    if (count > maxCount) {
      maxCount = count;
      targetYearMonth = yearMonth;
    }
  }

  if (targetYearMonth) {
    return targetYearMonth;
  }

  const now = new Date();
  const fallbackMonth = String(now.getMonth() + 1).padStart(2, "0");
  return `${now.getFullYear()}-${fallbackMonth}`;
}

export function buildHomeSeoMeta(payload = {}) {
  const releases = Array.isArray(payload?.data) ? payload.data : [];
  const count = releases.length;
  const title = count > 0
    ? `What to Watch Next: ${count} TV Premieres | PremiereLens`
    : "What to Watch Next: TV Premieres | PremiereLens";

  const topShows = [...releases]
    .filter((show) => show.title && typeof show.rating === "number")
    .sort((left, right) => right.rating - left.rating)
    .slice(0, 2)
    .map((show) => show.title);

  let description;
  if (topShows.length >= 2 && count > 2) {
    description = `Find what to watch next: ${topShows[0]}, ${topShows[1]} and ${count - 2} more TV premieres in the next 30 days, plus shows like the ones you love.`;
  } else if (topShows.length >= 1) {
    description = `Find what to watch next: ${topShows[0]} and more scripted TV premieres in the next 30 days, plus shows like the ones you love.`;
  } else {
    description = "Find what to watch next: scripted TV premieres in the next 30 days, plus shows like the ones you love, matched by taste across the PremiereLens archive.";
  }

  return {
    title,
    description,
    pathname: "/",
    canonicalUrl: `${SITE_URL}/`,
    ogUrl: `${SITE_URL}/`,
    image: `${SITE_URL}/og-image.jpg`,
    robots: "index,follow",
    ogType: "website",
  };
}
